const adminSettings = {
  wecomEmail: {
    cancel: 'Cancel',
    invalidDomains:
      'Enter full domains such as company.com, without @, wildcards, or URLs. Up to 100 domains.',
    completePolicy: 'Select a WeCom email field and enter at least one allowed domain.',
    domainsPlaceholder:
      'For example: company.com\nsubsidiary.com (one per line or separated by commas)',
    close: 'Close account binding',
    title: 'Account binding',
    titleWithName: 'Account binding / {{name}}',
    governance:
      'After users authorize their work email, AI Hub matches an existing account with the same email, links it and signs them in. Administrators maintain accounts and emails in Organization management. No separate registration is needed.',
    mode: 'First binding method',
    manual: 'Pause automatic matching (manual fallback)',
    emailMatch: 'Work email matching',
    field: 'WeCom email field',
    selectField: 'Choose a field',
    contactEmail: 'Directory email (email)',
    businessEmail: 'Business email (biz_mail)',
    domains: 'Allowed email domains',
    domainsHelp:
      'Enter one domain per line or separate domains with commas, e.g. jototech.cn, example.com. Use domains only, without @ or wildcards. Matching is exact; add subdomains separately. Up to 100 domains.',
    savePolicy: 'Save policy',
    saved: 'Saved',
    failed: 'Could not save. Check the email matching settings and try again.',
    conflict:
      'Configuration or account state changed. Close and reopen to review the latest state.',
  },
  actions: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    createAdmin: 'New',
    createCredential: 'New credential',
    delete: 'Delete',
    disable: 'Disable',
    edit: 'Edit',
    enable: 'Enable',
    manage: 'Manage',
    resetPassword: 'Reset password',
    retry: 'Retry',
    save: 'Save',
  },
  adminAccounts: {
    columnSelector: {
      label: 'Choose admin account columns',
      trigger: 'Columns',
    },
    description: 'Manage admin accounts, roles, and status.',
    createModal: {
      close: 'Close',
      confirm: 'Create admin',
      email: 'Email address',
      emailPlaceholder: 'name@company.com',
      mustChangePassword: 'Require password change on first sign-in',
      name: 'Admin name',
      namePlaceholder: 'Enter admin name',
      title: 'Create admin account',
      validation: {
        emailInvalid: 'Enter a valid email address',
        emailRequired: 'Email is required',
        nameRequired: 'Admin name is required',
      },
    },
    drawer: {
      adminId: 'Admin ID',
      email: 'Admin email account',
      lastActiveAt: 'Last active',
      name: 'Admin name',
      namePlaceholder: 'Enter admin name',
      role: 'Role',
      status: 'Status',
      titleWithAdmin: 'Manage admin account / {{name}}',
      validation: {
        nameRequired: 'Admin name is required',
      },
    },
    empty: 'No admin accounts yet',
    resetPasswordModal: {
      close: 'Close',
      confirm: 'Confirm reset',
      description: 'Reset the password for {{email}}?',
      impact:
        'Creates a temporary password; old sessions end, next sign-in requires a password change.',
      title: 'Confirm password reset',
    },
    role: {
      admin: 'Admin',
      superAdmin: 'Super admin',
      unknown: 'Unknown',
      viewer: 'Viewer',
    },
    searchLabel: 'Search admin name',
    searchPlaceholder: 'Search admin name',
    status: {
      active: 'Active',
      banned: 'Disabled',
    },
    sort: {
      createdAtAsc: 'Sort by created time ascending',
      createdAtDesc: 'Sort by created time descending',
      lastActiveAtAsc: 'Sort by last active time ascending',
      lastActiveAtDesc: 'Sort by last active time descending',
    },
    table: {
      actions: 'Actions',
      createdAt: 'Created',
      email: 'Admin email account',
      lastActiveAt: 'Last active',
      name: 'Admin name',
      role: 'Role',
      status: 'Status',
    },
    title: 'Admin accounts',
    workspaceLabel: 'Admin accounts workspace',
  },
  adpCredentials: {
    deleteDialog: {
      close: 'Close',
      confirm: 'Delete',
      failed: 'Failed to delete credential',
      message: 'Delete "{{name}}"? Credentials referenced by Tencent ADP apps cannot be deleted.',
      title: 'Delete ADP credential',
    },
    description:
      'Manage the Tencent Cloud SecretId, SecretKey, and API endpoints reused by Tencent ADP apps.',
    empty: 'No ADP credentials yet',
    feedback: {
      createFailed: 'Failed to create credential',
      validationFailed: 'Credential test failed',
      validationPassed: 'Credential test passed',
      validationPassedDetail: 'Credential connection is working and can access Tencent ADP.',
      updateFailed: 'Failed to update credential',
    },
    form: {
      close: 'Close',
      create: 'Create credential',
      createSubtitle: 'After saving, it can be selected when creating Tencent ADP apps.',
      createTitle: 'Create ADP credential',
      editTitle: 'Edit ADP credential / {{name}}',
      fields: {
        name: 'Credential name',
        openapiEndpoint: 'OpenAPI Endpoint',
        region: 'Tencent Cloud region',
        secretId: 'Tencent SecretId',
        secretKey: 'Tencent SecretKey',
      },
      hideSecret: 'Hide secret',
      placeholders: {
        name: 'Example: production Tencent credentials',
        secretId: 'Enter Tencent SecretId',
        secretKey: 'Enter Tencent SecretKey',
        secretKeyEdit: 'Leave blank to keep the saved SecretKey',
      },
      secretGuide: {
        link: 'Go to Tencent Cloud API key management',
        tooltip:
          'Create or copy the SecretId and SecretKey in Tencent Cloud Console / Access Management / API Key Management.',
      },
      secretPreserveHint: 'Saved {{value}}; leave blank to keep it.',
      showSecret: 'Show secret',
      testCredential: 'Test connection',
      update: 'Save changes',
    },
    loadDescription: 'Failed to load ADP credentials. Please try again later.',
    loadTitle: 'Unable to load ADP credentials',
    table: {
      actions: 'Actions',
      endpoint: 'OpenAPI Endpoint',
      name: 'Credential name',
      region: 'Region',
      secretId: 'SecretId',
      updatedAt: 'Updated',
    },
    title: 'ADP credentials',
    validation: {
      endpointInvalid: 'OpenAPI Endpoint must start with http:// or https://',
      endpointRequired: 'OpenAPI Endpoint is required',
      nameRequired: 'Credential name is required',
      regionRequired: 'Tencent Cloud region is required',
      secretIdRequired: 'Tencent SecretId is required',
      secretKeyRequired: 'Tencent SecretKey is required',
    },
    workspaceLabel: 'ADP credentials workspace',
  },
  wecomIdentityProfiles: {
    entry: {
      enabled: 'Enable identity profile',
      title: 'WeCom workbench entry',
      copy: 'Copy link',
      copied: 'Entry link copied',
      copyFailed: 'Could not copy. Select the link and copy it manually.',
      help: 'Set this as the home page of your WeCom app. Open it in WeCom to sign in and view your apps.',
    },

    actions: {
      create: 'Create identity source',
      deleteReferenced: 'Referenced; cannot delete',
      validate: 'Test connection',
    },
    deleteDialog: {
      close: 'Close delete confirmation',
      confirm: 'Delete',
      message: 'Delete “{{name}}”? This action cannot be undone.',
      title: 'Delete WeCom identity source',
    },
    connection: {
      blocked: 'Unavailable',
      ready: 'Available',
    },
    description:
      'Manage shared WeCom Corp IDs, Agent IDs, and App Secrets for applications to select when connecting a Bot.',
    empty: 'No WeCom identity sources',
    feedback: {
      createFailed: 'Failed to create the identity source. Check the settings and try again.',
      createSuccess: 'WeCom identity source created',
      deleteFailed:
        'Failed to delete the identity source. Check that no Bot or identity binding references it.',
      deleteSuccess: 'WeCom identity source deleted',
      disableSuccess: 'WeCom identity source disabled',
      enableSuccess: 'WeCom identity source enabled',
      secretVersionStale: 'The configuration has changed. Refresh and try again.',
      statusFailed: 'Failed to update identity source status. Try again later.',
      updateFailed: 'Failed to update the identity source. Try again later.',
      updateSuccess: 'WeCom identity source updated',
      validateComplete: 'Identity source check completed',
      validateFailed: 'Unable to check the identity source. Try again later.',
    },
    form: {
      close: 'Close identity source form',
      create: 'Create identity source',
      createSubtitle:
        'Application admins can select this source when configuring a WeCom IM integration.',
      createTitle: 'Create WeCom identity source',
      editTitle: 'Edit WeCom identity source / {{name}}',
      fields: {
        agentId: 'Agent ID',
        appSecret: 'App Secret',
        corpId: 'Corp ID',
        name: 'Identity source name',
      },
      hideSecret: 'Hide App Secret',
      identityImmutable:
        'This value is immutable after creation. Create a new source to change the enterprise or application.',
      placeholders: {
        agentId: 'Enter the WeCom custom app Agent ID',
        corpId: 'Enter the enterprise ID starting with ww',
        name: 'For example: Production WeCom',
        secret: 'Enter the WeCom custom app Secret',
        secretEdit: 'Saved. Leave blank to keep it',
      },
      secretPreserveHint:
        'The saved App Secret is never displayed. Leave blank to keep it, or enter a new value to rotate it.',
      showSecret: 'Show App Secret',
      update: 'Save changes',
    },
    loadDescription: 'Failed to load WeCom identity sources. Try again later.',
    loadTitle: 'Unable to load WeCom identity sources',
    permissionDescription:
      'Only system administrators can create, test, rotate, disable, or delete WeCom identity sources.',
    permissionTitle: 'You cannot manage WeCom identity sources',
    readiness: {
      actionFallback: {
        blocked: 'Correct the blocked configuration and run the connection test again.',
        unknown: 'The connection test could not be completed. Try again later.',
      },
      actions: {
        profile_agent_accessible: 'Check the Agent ID and application permissions, then try again.',
        profile_agent_active: 'The Agent is disabled. Enable it in WeCom and try again.',
        profile_credential_valid:
          'Check the Corp ID, Agent ID, and App Secret, then run the test again.',
      },
      description: {
        blocked: 'Configuration or platform permissions are blocked. Follow the suggested actions.',
        ready: 'The credentials are valid and the WeCom application is accessible.',
        unknown: 'The connection test could not be completed. Try again later.',
      },
      status: {
        blocked: 'Blocked',
        ready: 'Ready',
        unknown: 'Temporarily unavailable',
      },
      title: 'Connection test result',
    },
    references: {
      summary: '{{integrations}} Bots · {{bindings}} bindings',
    },
    status: {
      active: 'Enabled',
      disabled: 'Disabled',
    },
    table: {
      actions: 'Actions',
      name: 'Identity source',
      connection: 'Connection',
      references: 'References',
      status: 'Status',
    },
    title: 'WeCom identity sources',
    validation: {
      agentId: 'Enter an Agent ID',
      appSecret: 'Enter an App Secret',
      corpId: 'Enter a Corp ID',
      name: 'Enter an identity source name',
    },
    workspaceLabel: 'WeCom identity source workspace',
  },
  common: {
    allStatuses: 'All statuses',
  },
  businessNavigation: {
    application: 'Linked application',
    applicationHint:
      'Show this link only when the user can access the application on the current channel. Standalone external links do not need an application.',
    noApplication: 'No linked application',
    unavailableApplication: 'Linked application unavailable',
    retryApplications: 'Reload applications',
    cardDescription:
      'When enabled, a fixed-style external entry appears below App Center in the user sidebar.',
    cardTitle: 'External business entry',
    description: 'Configure one external business-system entry in the user sidebar.',
    enabled: 'Enable business navigation',
    label: 'Menu label',
    labelPlaceholder: 'For example: ADP Workspace',
    loadDescription: 'Failed to load business navigation settings. Please try again later.',
    loadTitle: 'Unable to load business navigation',
    preview: 'Sidebar preview',
    previewHint: 'The entry stays below App Center and always opens in a new tab.',
    previewLabel: 'External workspace',
    save: 'Save settings',
    saveFailed: 'Failed to save business navigation. Check the settings and try again.',
    saved: 'Business navigation saved',
    title: 'Business navigation',
    url: 'Destination URL',
    urlHint: 'HTTPS only, without embedded credentials. Do not put tokens in the URL.',
    validation: {
      labelRequired: 'Enter a menu label',
      labelTooLong: 'The menu label cannot exceed 20 characters',
      urlInvalid: 'Enter a valid HTTPS URL without embedded credentials',
      urlRequired: 'Enter a destination URL',
    },
  },
  branding: {
    assetDeleteFailed: 'Failed to delete the brand asset. Please try again later.',
    assetDeleted: {
      favicon: 'Favicon reset to the default icon',
      logo: 'Logo reset to the default icon',
    },
    assetNames: {
      favicon: 'favicon',
      logo: 'logo',
    },
    assetUploadFailed: 'Failed to upload the brand asset. Check the file and try again.',
    assetUploaded: {
      favicon: 'Favicon uploaded',
      logo: 'Logo uploaded',
    },
    assetsDescription:
      'Logo is used on sign-in and sidebar branding; favicon is used for the browser tab icon. Uploads are saved immediately.',
    assetsTitle: 'Brand assets',
    basicDescription:
      'Set the site title and description. The title syncs to sign-in pages, sidebar brand text, and browser titles.',
    basicTitle: 'Basic information',
    conversationDescription:
      'Configure the Hub Agent name, home welcome message, and user message style.',
    conversationTitle: 'Conversation experience',
    description: 'Configure AI Hub site information, conversation experience, and brand assets.',
    descriptionHint:
      'Used for browser metadata, sign-in supporting copy, and future public surfaces.',
    emptyAsset: 'Not set',
    faviconHint: 'Recommended size: 32x32px. Supports ICO, PNG, JPG, WebP, and GIF.',
    faviconPreviewAlt: 'Favicon preview',
    faviconTitle: 'Browser icon (favicon)',
    fields: {
      chatUserBubbleColor: 'User message bubble color',
      chatUserBubbleColorPicker: 'Choose the user message bubble color',
      description: 'Site description',
      hubAgentName: 'Hub Agent name',
      hubAgentWelcomeTitle: 'Home welcome title',
      title: 'Site title',
    },
    hints: {
      chatUserBubbleColor:
        'Applies globally to user-sent messages. Text switches between black and white automatically for readability.',
      hubAgentName: 'Up to 20 characters. Save an empty value to restore Hub Agent.',
      hubAgentWelcomeTitle:
        'Up to 60 characters. Save an empty value to use the localized default welcome message.',
    },
    loadDescription: 'Failed to load branding settings. Please try again later.',
    loadTitle: 'Unable to load branding settings',
    logoHint: 'Recommended size: 64x64px. Supports PNG, JPG, WebP, and GIF.',
    logoPreviewAlt: 'Logo preview',
    logoTitle: 'Site logo',
    placeholders: {
      description: 'User-facing product description',
      hubAgentName: 'Example: Hub Agent',
      hubAgentWelcomeTitle: 'Example: How can I help today?',
      title: 'Example: AI Hub',
    },
    preview: {
      chatUserBubble: 'User message preview',
    },
    resetAsset: 'Reset',
    resetDialog: {
      cancel: 'Cancel',
      close: 'Close',
      confirm: 'Reset',
      message:
        'This removes the uploaded {{asset}} and restores the preview to the system default logo.',
      title: 'Reset brand asset',
    },
    saveSettings: 'Save settings',
    title: 'Branding',
    uploadAsset: 'Upload',
    uploadingAsset: 'Uploading',
    validation: {
      chatUserBubbleColorInvalid: 'Enter a color in #RRGGBB format',
      hubAgentNameTooLong: 'Hub Agent name cannot exceed 20 characters',
      hubAgentWelcomeTitleTooLong: 'Home welcome title cannot exceed 60 characters',
      titleRequired: 'Site title is required',
    },
    workspaceBackground: {
      assetsSection: 'Assets',
      baseColor: 'Base color',
      cancel: 'Cancel',
      chooseImage: 'Choose image',
      composition: 'Composition',
      configure: 'Configure background',
      configured: 'Workspace background configured',
      confirmDelete: 'Delete background',
      conversationState: 'Conversation',
      delete: 'Restore default',
      deleteDescription:
        'This removes the workspace background and separate mobile source. The user workspace returns to its default solid color.',
      deleteFailed: 'Failed to delete the workspace background. Please try again later.',
      deleted: 'Workspace background restored to default',
      deleteTitle: 'Restore the default workspace background',
      description:
        'Upload one desktop source and adjust its focal point in the real desktop, laptop, and mobile workspace shells. A separate mobile source is optional.',
      devicePreview: 'Preview device',
      devices: {
        desktop: 'Desktop',
        laptop: 'Laptop',
        mobile: 'Mobile',
      },
      displaySection: 'Display',
      editorSubtitle: 'Edit on a dedicated canvas · Preview the real runtime state',
      emptyState: 'Empty chat',
      enabled: 'Enable background',
      horizontalFocus: 'Horizontal focus',
      imageOpacity: 'Background visibility',
      imageOpacityHint:
        'Recommended: 32% · Adjustable from 10%–70%; text readability protection is handled separately.',
      invalidFile: 'Choose a PNG, JPEG, or WebP image up to 10MB.',
      mobileConversationMode: 'Mobile conversation',
      mobileImage: 'Separate mobile source (optional)',
      mobileModes: {
        background: 'Keep a low-intensity background',
        base_color: 'Use only the base color (recommended)',
      },
      noImage: 'No image selected',
      notConfigured: 'No workspace background configured',
      previewBaselines: 'Desktop 1920×1080 · Laptop 1440×900 · Mobile 390×844',
      previewState: 'Preview state',
      previewConversationAssistant:
        'Hello, I am ready to help with your learning and campus tasks.',
      previewConversationTitle: 'Today’s study plan',
      previewConversationUser: 'Help me plan today’s study tasks.',
      previewWelcomeTitle: 'How can I help you today?',
      primaryImage: 'Desktop source',
      removeImage: 'Remove',
      resetCrop: 'Reset current crop',
      save: 'Save and publish',
      saveFailed: 'Failed to publish the workspace background. Check the image and crop settings.',
      saved: 'Workspace background published',
      storedImage: 'Published source',
      title: 'Workspace background',
      verticalFocus: 'Vertical focus',
      zoom: 'Zoom',
    },
  },
  coreAgent: {
    allowedModels: 'Selected models',
    defaultModel: 'Default model',
    defaultModelPlaceholder: 'Select a default model',
    description: 'Configure the {{hubAgentName}} chat entry on the AI Hub home page.',
    enableDescription: 'When disabled, the user portal hides the {{hubAgentName}} entry.',
    enableTitle: 'Enable {{hubAgentName}}',
    loadDescription: 'Failed to load {{hubAgentName}} settings. Please try again later.',
    loadTitle: 'Unable to load {{hubAgentName}} settings',
    modelsDescription: 'Only registered active models can be selected for {{hubAgentName}}.',
    modelsTitle: 'Models',
    modelPicker: {
      allProviders: 'All providers',
      apply: 'Apply selection',
      empty: 'No matching models',
      noSelection: 'No models selected',
      open: 'Select models',
      otherProvider: 'Other providers',
      providerGroups: 'Model provider groups',
      searchLabel: 'Search models',
      searchPlaceholder: 'Search model name or provider',
      selectedCount: '{{count}} models selected',
      title: 'Select models',
    },
    noModels: 'No available registered models',
    showToolDetails: 'Show Tool details',
    showToolDetailsHint:
      'When off, chat still shows whether each Tool completed or failed, without exposing its input and output.',
    systemPrompt: 'System prompt',
    systemPromptHint: 'Used as the system prompt for every {{hubAgentName}} conversation.',
    systemPromptPlaceholder: 'You are AI Hub global assistant.',
    title: '{{hubAgentName}} settings',
    viewerNotice: 'Viewer access is read-only for Hub Agent settings and Tool selection.',
    validation: {
      allowedModelsRequired: 'Select at least one model when enabled',
      defaultModelMustBeAllowed: 'The default model must be in the allowed models',
      defaultModelRequired: 'Select a default model when enabled',
    },
  },
  sso: {
    actions: {
      configure: 'Configure',
      configureProvider: 'Configure {{provider}}',
      edit: 'Edit config',
      editProvider: 'Edit {{provider}}',
      test: 'Test connection',
    },
    description: 'Manage member sign-in methods, including SSO protocols and email/password.',
    drawer: {
      title: 'Member authentication / {{provider}}',
    },
    flow: {
      connectionTitle: 'Protocol connection',
      identityTitle: 'Account matching and creation',
      next: 'Next',
      previous: 'Previous',
      progressLabel: 'SSO configuration steps',
      sections: {
        connection: 'Connection',
        identity: 'Account matching',
      },
      tabsLabel: 'SSO configuration sections',
    },
    bridge: {
      customSource: 'Custom field',
      customSourceField: 'Custom external field',
      customSourceHint:
        'Only a non-empty top-level string is supported. Nested paths, expressions, and fallbacks are not supported.',
      customSourcePlaceholder: 'For example, employee_id',
      externalField: 'External identity field',
      hubField: 'Hub account field',
      mappingHelp:
        'On the first sign-in, Hub uses the external identity field value to find the selected Hub account field. A unique match creates a permanent binding, so later sign-ins do not match again. Migrate existing identities before changing either field after bindings exist.',
      mappingTitle: 'Account matching rule',
      targets: {
        email: 'Hub: email',
        external_person_id: 'Hub: external user id',
      },
    },
    autoRedirect: 'Redirect to enterprise SSO',
    autoRedirectDescription:
      'Send visits to the user /login route directly to the current IdP. The fixed password entry remains /login/password.',
    enableEmail: 'Email and password',
    enableEmailDescription:
      'Control whether the default /login page shows email/password. The fixed recovery entry at /login/password always remains available.',
    enableSso: 'SSO sign-in',
    enableSsoDescription:
      'Show the SSO entry on the user sign-in page and authenticate with the selected protocol.',
    fields: {
      acs_url: 'ACS URL',
      algorithm: 'Algorithm',
      authorization_endpoint: 'Authorization Endpoint',
      authorization_url: 'Authorization URL',
      cas_base_url: 'CAS server URL',
      cas_match_attribute: 'Hub local identity field',
      client_id: 'Client ID',
      client_secret: 'Client Secret',
      end_session_endpoint: 'End Session Endpoint',
      idp_entity_id: 'IdP Entity ID',
      idp_slo_url: 'IdP SLO URL',
      idp_sso_url: 'IdP SSO URL',
      idp_x509_cert: 'IdP x509 Cert',
      issuer: 'Issuer URL',
      jwks_uri: 'JWKS URL',
      logout_redirect_url: 'Logout Redirect URL',
      logout_url: 'Logout URL',
      oauth2_subject_claim: 'User ID field',
      scope: 'Scope',
      sp_entity_id: 'SP Entity ID',
      sp_private_key: 'SP Private Key',
      sp_x509_cert: 'SP x509 Cert',
      token_endpoint: 'Token Endpoint',
      token_url: 'Token URL',
      userinfo_endpoint: 'Userinfo Endpoint',
      userinfo_url: 'Userinfo URL',
    },
    loadDescription: 'Failed to load member authentication settings. Please try again later.',
    loadTitle: 'Unable to load member authentication settings',
    methodsDescription:
      'Control which sign-in methods appear on the user sign-in page. Keep at least one.',
    methodsTitle: 'Sign-in methods',
    placeholders: {
      acs_url: 'https://hub.example.com/v1/api/app/auth/sso/callback',
      algorithm: 'RS256',
      authorization_endpoint: 'https://idp.example.com/oauth2/v1/authorize',
      authorization_url: 'https://idp.example.com/oauth2/authorize',
      cas_base_url: 'https://sso.example.com/cas',
      client_id: 'portal-client-id',
      client_secret: 'Enter client secret',
      end_session_endpoint: 'https://idp.example.com/oauth2/v1/logout',
      idp_entity_id: 'https://idp.example.com/metadata',
      idp_slo_url: 'https://idp.example.com/slo',
      idp_sso_url: 'https://idp.example.com/sso',
      idp_x509_cert: 'Paste the IdP certificate',
      issuer: 'https://idp.example.com',
      jwks_uri: 'https://idp.example.com/.well-known/jwks.json',
      logout_redirect_url: 'https://hub.example.com/login',
      logout_url: 'https://idp.example.com/logout',
      oauth2_subject_claim: 'id',
      scope: 'openid profile email',
      secretWithSaved: 'Saved {{value}}; leave blank to keep',
      sp_entity_id: 'aihub-portal',
      sp_private_key: 'Paste the SP private key',
      sp_x509_cert: 'Paste the SP certificate',
      token_endpoint: 'https://idp.example.com/oauth2/v1/token',
      token_url: 'https://idp.example.com/oauth2/token',
      userinfo_endpoint: 'https://idp.example.com/oauth2/v1/userinfo',
      userinfo_url: 'https://idp.example.com/oauth2/userinfo',
    },
    providers: {
      cas: {
        configuration:
          'CAS only needs its protocol context URL. Hub derives the login, serviceValidate, and logout endpoints.',
        description: 'For identity providers compatible with CAS 2.0.',
        new: 'Enable CAS',
        title: 'CAS',
      },
      oauth2: {
        configuration:
          'OAuth2 requires authorization, token, and userinfo endpoints, plus the field that contains the unique user ID.',
        description: 'For generic OAuth2 providers.',
        new: 'Enable OAuth2',
        title: 'OAuth2',
      },
      oidc: {
        configuration:
          'OIDC requires issuer, authorization, token, userinfo endpoints, and client secret.',
        description: 'For enterprise identity providers that support OpenID Connect.',
        new: 'Enable OIDC',
        title: 'OIDC',
      },
      saml: {
        configuration: 'SAML requires IdP, SP, ACS, and certificate parameters.',
        description: 'For enterprise SAML 2.0 identity providers.',
        new: 'Enable SAML',
        title: 'SAML',
      },
    },
    providersDescription:
      'Choose CAS, SAML, OIDC, or OAuth2 for member authentication. Saving a new protocol replaces the current one.',
    providersTitle: 'SSO protocol',
    jit: {
      help: {
        cas: 'When disabled, users without one matching account are denied. When enabled, Hub can create a regular member, but CAS attributes must return email, mail, or userPrincipalName. No permissions are granted automatically.',
        oauth2:
          'When disabled, users without one matching account are denied. When enabled, Hub can create a regular member, but OAuth2 UserInfo must return a usable email. No permissions are granted automatically.',
        oidc: 'When disabled, users without one matching account are denied. When enabled, Hub can create a regular member, but the OIDC ID Token or UserInfo must return a usable email. No permissions are granted automatically.',
        saml: 'When disabled, users without one matching account are denied. When enabled, Hub can create a regular member, but the SAML assertion must return a usable email attribute. No permissions are granted automatically.',
      },
      title: 'Create accounts automatically (JIT)',
    },
    status: {
      configured: 'Configured',
      incomplete: 'Incomplete',
    },
    test: {
      failed: 'Connection test failed',
      success: 'Connection test passed',
      warning: 'Connection test returned a warning',
    },
    title: 'Member authentication',
    updatedAt: 'Updated: {{time}}',
    validation: {
      configRequired: 'Configure one protocol completely before enabling SSO.',
      oneLoginRequired: 'Keep at least one sign-in method enabled.',
      redirectRequiresSso: 'Enable SSO sign-in before turning on automatic redirect.',
      required: 'This field is required',
    },
  },
  errors: {
    loadDescription: 'Failed to load admin accounts. Please try again later.',
    loadTitle: 'Unable to load admin accounts',
    submitFailed: 'Operation failed. Please try again later.',
  },
  mcpRuntime: {
    budgets: {
      description:
        'Limit the total duration and complete response size of each discovery and Tool execution.',
      title: 'Resource budgets',
    },
    close: 'Close MCP settings',
    description:
      'Manage the network policy and discovery / execution budgets shared by every MCP service.',
    feedback: {
      updated: 'MCP settings updated',
      updateFailed: 'Failed to update MCP settings. Refresh and try again.',
    },
    fields: {
      discoveryTimeoutMs: 'Discovery timeout (ms)',
      executionTimeoutMs: 'Execution timeout (ms)',
      maxDiscoveryResponseBytes: 'Maximum discovery response (bytes)',
      maxExecutionResponseBytes: 'Maximum execution response (bytes)',
      privateNetworkAllowlist: 'Private network allowlist',
    },
    globalNotice:
      'These settings apply to every MCP service. New connections use the current values automatically.',
    loadDescription: 'Unable to read the global MCP runtime policy. Try again later.',
    loadTitle: 'Unable to load MCP settings',
    network: {
      description:
        'Public HTTP(S) endpoints connect directly. Private targets must be reviewed and allowed here.',
      title: 'Network policy',
    },
    placeholders: {
      privateNetworkAllowlist: 'One hostname, IP, or CIDR per line',
    },
    title: 'MCP settings',
    validation: {
      positiveInteger: 'Enter a positive whole number.',
    },
  },
  pagination: {
    next: 'Next page',
    pageSize: '{{count}} / page',
    previous: 'Previous page',
  },
  success: {
    createAdminAccount: 'Admin account created',
    createAdpCredential: 'ADP credential created',
    deleteAdpCredential: 'ADP credential deleted',
    resetPassword: 'Password reset',
    updateAdminAccount: 'Admin account updated',
    updateAdpCredential: 'ADP credential updated',
    updateBrandingSettings: 'Branding settings updated',
    updateCoreAgentSettings: '{{hubAgentName}} settings updated',
    updateSsoSettings: 'Member authentication settings updated',
    updateStatus: 'Admin status updated',
  },
  temporaryPassword: {
    account: 'Account',
    close: 'Close',
    copied: 'Copied',
    copy: 'Copy',
    copyAccount: 'Copy account',
    copyFailed: 'Copy failed. Copy manually instead.',
    copyPassword: 'Copy password',
    password: 'Password',
    resetHelp:
      'Old sessions are signed out. First sign-in requires a password change. This appears once.',
    resetTitle: 'Password reset',
    title: 'Account created',
  },
}

export default adminSettings
